import {Component, input} from '@angular/core';
import {Sidebar} from '../sidebar/sidebar';
import {StyleClass} from 'primeng/styleclass';
import {SidebarData} from '../interface/sidebar';
import {RouterOutlet} from '@angular/router';
import {BreadcrumbComponent} from '../shared/breadcrumb/breadcrumb';
import {ThemeService} from '../theme.service';
import {Button} from 'primeng/button';

@Component({
  selector: 'app-layout',
  imports: [
    Sidebar,
    StyleClass,
    RouterOutlet,
    BreadcrumbComponent,
    Button,
  ],
  templateUrl: './layout.html',
  styleUrl: './layout.css',
  standalone: true
})
export class Layout {
  sidebar = input<SidebarData>();

  constructor(public themeService: ThemeService) {}
}
